import React from "react";
import {Comment, Container, Header} from "semantic-ui-react";
import {Comments as FbComments, FacebookProvider} from 'react-facebook';
import {FormattedMessage} from "react-intl";

import {APP} from "../../../constants";
import {useLocation} from "react-router";

export const Comments = () => {

    const location = useLocation();
    const shareUrl = 'https://inbh.com.br' + location.pathname;

    return (
        <Container as="section" id={"comments"} className="section-comments">
            <Header as="h2" className="mb-0">
                <FormattedMessage id="Comentários"/>
            </Header>

            <Container className="details-comments">
                <Comment.Group>
                    <FacebookProvider
                        id={'facebook-comments'}
                        language={'pt_BR'}
                        appId={APP.fbid}
                    >
                        <FbComments
                            href={shareUrl}
                        />
                    </FacebookProvider>
                </Comment.Group>
            </Container>
        </Container>
    );
};
